// extracted by mini-css-extract-plugin
export default {"textarea":"styles_textarea__Ki7FI","textarea_error":"styles_textarea_error__pM56T","error":"styles_error__UEN2Y"};